export const VENDURE_API_URL = process.env.NEXT_PUBLIC_VENDURE_API_URL || "";
export const NEXUS_API_URL = process.env.NEXT_PUBLIC_NEXUS_API_URL || "";
export const ZAMAWIAM_TO_FE_URL =
  process.env.NEXT_PUBLIC_ZAMAWIAM_TO_FE_URL || "";
